module.exports = __webpack_public_path__ + "static/storm_giant-04ca7ce5521506672c81283d412a2207.jpeg";